import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { TextAccent, Link, ArrowExternal } from '../../../components';
import { Wrapper, Section, LogosWrapper, ImageWrapper } from './Costco.style';

/**
 * Work/Sesame: Collaboration with Costco
 */
const Costco = () => {
  const data = useStaticQuery(graphql`
    query {
      sesameCostcoLogo: file(relativePath: { eq: "sesame-costco-logo.png" }) {
        childImageSharp {
          fixed(width: 325) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      costcoStore: file(relativePath: { eq: "sesame-costco.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 768) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <Wrapper>
      <Section>
        <div>
          <ImageWrapper>
            <Img
              fluid={data.costcoStore.childImageSharp.fluid}
              loading="eager"
              imgStyle={{ objectFit: 'contain' }}
              alt="Image of Costco store exterior"
            />
          </ImageWrapper>
          <LogosWrapper>
            <Img
              fixed={data.sesameCostcoLogo.childImageSharp.fixed}
              loading="eager"
              objectFit="cover"
              objectPosition="50% 50%"
              alt="Image of Costco and Sesame logos side by side"
            />
          </LogosWrapper>
          <TextAccent withSpacing>
            In 2023, we focused on scaling our B2B2C partnerships and driving high-volume user onboarding. I led the
            launch of <strong>Sesame @ Work</strong>, a program that gave employees and customers of major partners
            access to Sesame’s services, proving that B2B2C acquisition could scale without compromising reliability or
            compliance.
          </TextAccent>
          <TextAccent>
            I led the initiative end-to-end, from researching and defining the onboarding strategy to coordinating work
            and driving implementation. By designing flows that enabled users to onboard before full authentication or
            eligibility checks, we <strong>captured 75% of the 2023 funnel</strong>, laying the groundwork for the
            provisional membership model later{' '}
            <Link isExternalLink to="https://archive.ph/VSCe5#selection-4533.34-4533.51">
              <strong>adopted by Costco</strong>
              <ArrowExternal />
            </Link>{' '}
            and other large partners.
          </TextAccent>
        </div>
      </Section>
    </Wrapper>
  );
};

export default Costco;
